export { default } from './InfoIcon';
